import Vue from "vue";
import Router from "vue-router";
// import Index from "./views/Index.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import SignIn from "./views/SignIn.vue";
import Profile from "./views/Profile.vue";
import ErrorPage from "./views/Error.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

import App from "./views/App.vue";
import { auth } from "firebase";

Vue.use(Router);

function requireAuth(to, from, next) {
  let currentUser = auth().currentUser;
  if (currentUser) {
    switch (to.meta.permission) {
      /*
          If the route that requires authentication is a user, then we continue.
          All users can access these routes
        */
      case "user":
        next();
        break;
    }
  } else {
    next("/login");
  }
}

function checkLogin(to, from, next) {
  if (!auth().currentUser) {
    next();
  } else {
    next("/app");
  }
}

export default new Router({
  routes: [
    {
      path: "/",
      name: "landing",
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 150 },
        footer: { backgroundColor: "black" }
      },
      beforeEnter: checkLogin
    },
    {
      path: "/login",
      name: "login",
      components: { default: Login, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 }
      },
      beforeEnter: checkLogin
    },
    {
      path: "/signin",
      name: "signin",
      components: { default: SignIn, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 }
      },
      beforeEnter: checkLogin
    },
    {
      path: "/profile",
      name: "profile",
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      beforeEnter: checkLogin
    },
    {
      path: "/app",
      name: "app",
      components: { default: App, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "green" }
      },
      beforeEnter: requireAuth,
      meta: {
        permission: "user"
      }
    },
    {
      path: "/*",
      name: "error page",
      components: { default: ErrorPage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    }
  ],

  // mode: "history",

  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
